import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API_ENDPOINTS, fetchWithCredentials } from '../config/api';
import { useAuth } from '../contexts/AuthContext';
import './AuthPage.css';

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  // 获取重定向路径，如果没有则默认为首页
  const from = location.state?.from?.pathname || '/';

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // 注册时验证密码
    if (!isLogin && formData.password !== formData.confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }

    try {
      const endpoint = isLogin ? API_ENDPOINTS.AUTH.LOGIN : API_ENDPOINTS.AUTH.REGISTER;
      // 注册时不需要发送 confirmPassword
      const { confirmPassword, ...dataToSend } = formData;
      const response = await fetchWithCredentials(endpoint, {
        method: 'POST',
        body: JSON.stringify(dataToSend)
      });

      if (isLogin) {
        // 登录成功
        if (response.token) {
          login(response.token);
          navigate(from, { replace: true });
        } else {
          setError('登录响应格式错误');
        }
      } else {
        // 注册成功
        setSuccess('注册成功！正在跳转到登录页面...');
        // 2秒后切换到登录页面
        setTimeout(() => {
          setIsLogin(true);
          setFormData({
            email: formData.email,
            password: '',
            confirmPassword: ''
          });
          setSuccess('');
        }, 2000);
      }
    } catch (err) {
      console.error('认证错误:', err);
      // 处理错误信息
      if (err.message.includes('Invalid credentials')) {
        setError('账号或密码错误，无法登录！');
      } else if (err.message.includes('User already exists')) {
        setError('该邮箱已被注册！');
      } else if (err.message.includes('登录已过期')) {
        setError('登录已过期，请重新登录');
      } else {
        setError(err.message || '操作失败，请稍后重试');
      }
      
      // 让错误信息保持显示一段时间
      setTimeout(() => {
        setError('');
      }, 5000); // 5秒后自动清除错误信息
    }
  };

  const handleToggle = () => {
    setIsLogin(!isLogin);
    setFormData({
      email: '',
      password: '',
      confirmPassword: ''
    });
    // 不清除错误信息，让用户能够看到
    // setError('');
    // setSuccess('');
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-box">
          <h2>{isLogin ? '登录' : '注册'}</h2>
          {error && (
            <div className="error-message">
              {error}
              <button 
                className="error-close-btn" 
                onClick={() => setError('')}
                title="关闭"
              >
                ×
              </button>
            </div>
          )}
          {success && (
            <div className="success-message">
              {success}
              <button 
                className="success-close-btn" 
                onClick={() => setSuccess('')}
                title="关闭"
              >
                ×
              </button>
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="邮箱"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                name="password"
                placeholder="密码"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            {!isLogin && (
              <div className="form-group">
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="确认密码"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                />
              </div>
            )}
            <button type="submit" className="submit-button">
              {isLogin ? '登录' : '注册'}
            </button>
          </form>
          <div className="switch-form">
            <button
              type="button"
              className="switch-button"
              onClick={handleToggle}
            >
              {isLogin ? '没有账号？点击注册' : '已有账号？点击登录'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage; 